module.exports = __webpack_public_path__ + "media/newstyle/images/user-account-en-4cd1ec2fdb8f7ff376eaf77a4b8697c5.png";